/**
 * Top-level routes:
 *   /              → Landing (name input + create / join controls)
 *   /room/:id      → Room (in-call view)
 *
 * Real pages land in T046 (Landing) and T052 (Room); Phase 2 ships
 * placeholders so the routing + provider stack can be smoke-tested.
 */
import { Route, Routes } from 'react-router'
import { Landing } from './pages/Landing.js'
import { Room } from './pages/Room.js'

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/room/:id" element={<Room />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

function NotFound() {
  return (
    <main>
      <h1>404</h1>
      <p>Page not found.</p>
    </main>
  )
}
